import { render, staticRenderFns } from "./nas.vue?vue&type=template&id=422d35a8&scoped=true&"
import script from "./nas.vue?vue&type=script&lang=js&"
export * from "./nas.vue?vue&type=script&lang=js&"
import style0 from "./nas.vue?vue&type=style&index=0&id=422d35a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422d35a8",
  null
  
)

export default component.exports